"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textLinkNeoDark = exports.textLinkNeoLight = exports.textLinkNovoDark = exports.textLinkNovo = exports.textLink = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const textLink = {
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    lineHeight: font_const_1.default.lineHeightSm,
    fontWeight: font_const_1.default.weightDefault,
    letterSpacing: undefined,
    textLinkColorPrimary: color_const_1.default.dodgerBlue,
    textLinkColorPrimaryHover: color_const_1.default.dodgerBlue300,
    textLinkColorPrimaryActive: color_const_1.default.dodgerBlue,
    textLinkColorPrimaryDisabled: color_const_1.default.dodgerBlue300,
    textLinkColorPrimarySelected: 'inherit',
    textLinkBackgroundColorPrimarySelected: 'inherit',
    textLinkMargin: '0',
    textLinkPadding: `0 ${spacing_const_1.default.xxs}`,
    textLinkBorderWidthFocus: '2px',
    textLinkBorderRadiusFocus: '2px',
    textLinkShadowColorFocus: color_const_1.default.dodgerBlue,
};
exports.textLink = textLink;
const textLinkNovo = {
    // Typography
    ...light.body02,
    textLinkMargin: '0',
    textLinkPadding: `0 ${light.spacing02}`,
    textLinkBorderWidthFocus: '2px',
    textLinkBorderRadiusFocus: '2px',
    textLinkShadowColorFocus: light.focus01,
    textLinkColorPrimary: light.action05,
    textLinkColorPrimaryHover: light.hover07,
    textLinkColorPrimaryActive: light.active07,
    textLinkColorPrimaryDisabled: light.disabled02,
    textLinkColorPrimarySelected: 'inherit',
    textLinkBackgroundColorPrimarySelected: 'inherit',
};
exports.textLinkNovo = textLinkNovo;
const textLinkNovoDark = {
    ...textLinkNovo,
    textLinkColorPrimary: dark.action05,
    textLinkColorPrimaryHover: dark.hover07,
    textLinkColorPrimaryActive: dark.active07,
    textLinkColorPrimaryDisabled: dark.disabled02,
    textLinkShadowColorFocus: dark.focus01,
};
exports.textLinkNovoDark = textLinkNovoDark;
const textLinkNeoLight = {
    ...textLinkNovo,
    textLinkShadowColorFocus: neoLight.focus01,
    textLinkColorPrimary: neoLight.action05,
    textLinkColorPrimaryHover: neoLight.hover07,
    textLinkColorPrimaryActive: neoLight.active07,
    textLinkColorPrimaryDisabled: neoLight.disabled02,
};
exports.textLinkNeoLight = textLinkNeoLight;
const textLinkNeoDark = {
    ...textLinkNovoDark,
    textLinkColorPrimary: neoDark.action05,
    textLinkColorPrimaryHover: neoDark.hover07,
    textLinkColorPrimaryActive: neoDark.active07,
    textLinkColorPrimaryDisabled: neoDark.disabled02,
    textLinkShadowColorFocus: neoDark.focus01,
};
exports.textLinkNeoDark = textLinkNeoDark;
